import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=72bde94c&scoped=true"
import script from "./FullLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FullLayout.vue?vue&type=style&index=0&id=72bde94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bde94c",
  null
  
)

export default component.exports